import React, { useState, useEffect, useContext } from 'react'
import { useTranslation } from 'react-i18next';

import styles from './styles.module.css'
import { mainContext } from '../../../MainContext';
import FadeinWrap from '../../../../common/animation/FadeinWrap';
import Customer1 from './item/Customer1';
import Customer2 from './item/Customer2';
import Customer3 from './item/Customer3';
import Customer4 from './item/Customer4';
import Customer5 from './item/Customer5';
import Customer6 from './item/Customer6';
import Customer7 from './item/Customer7';
import Customer8 from './item/Customer8';
import Customer9 from './item/Customer9';


function ContainerCustomer() {
  const { t } = useTranslation();

  const getLink = useContext(mainContext).getLink;

  useEffect(() => {
  }, [])


  return (
    <div className="margin-horizontal-auto">
      <FadeinWrap>
        <img src="./img/customer/children.jpg" className="w-100" alt="受講生の声" />
      </FadeinWrap>

      <img src={t('customer.title')} class="w-100" alt="受講生の声" />
      <p className={styles.subTitle}>{t('customer.subtitle')}</p>

      <div className={styles.itemWrap}>
        <Customer1 />
        <Customer2 />
        <Customer3 />
        <Customer4 />
        <Customer5 />
        <Customer6 />
        <Customer7 />
        <Customer8 />
        <Customer9 />
      </div>
    </div>
  );
}

export default ContainerCustomer;